// Others
import { urlApiPackage } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import { IPackage, IPackageDetail, IQueryParamListItemPackageOption } from '~/utils/interface/package';
import { IVariant } from '~/utils/interface/variant';

const packageApi = {
  getListPackage: (params: IQueryParamBase) => {
    const url = urlApiPackage.getListPackage;
    return axiosClient.get<IBaseResponse<IListDataResponse<IPackage[]>>>(url, { params });
  },

  getDetailPackage: (id: string) => {
    const url = urlApiPackage.getDetailPackage(id);
    return axiosClient.get<IBaseResponse<IPackageDetail>>(url);
  },

  createPackage: (formData: FormData) => {
    const url = urlApiPackage.createPackage;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deletePackage: (id: string) => {
    const url = urlApiPackage.deletePackage(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  updatePackage: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiPackage.updatePackage(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getListItemOptionalPackage: (id: string, params: IQueryParamListItemPackageOption) => {
    const url = urlApiPackage.getListItemOptionalPackage(id);
    return axiosClient.get<IBaseResponse<IListDataResponse<IVariant[]>>>(url, { params });
  },
};

export default packageApi;
